import { Tooltip } from "@/components/shared";
import { memo } from "react";

interface PositionMenuButtonProps {
    onClick: () => void;
    children: React.ReactNode;
    disabled?: boolean;
    tooltip?: string;
}

export const PositionMenuButton = memo(({ onClick, children, disabled, tooltip }: PositionMenuButtonProps) => {
    const btn = (
        <button
            className={
                disabled
                    ? "w-full cursor-not-allowed px-4 py-2 text-left text-sm text-dark/40"
                    : "w-full px-4 py-2 text-left text-sm text-dark hover:bg-primary/10"
            }
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );

    if (tooltip) {
        return <Tooltip title={tooltip}>{btn}</Tooltip>;
    }
    return btn;
});

PositionMenuButton.displayName = "PositionMenuButton";
